module.exports = __webpack_public_path__ + "static/media/icon-report-class-report.aa3d3b0d.svg";